import { jwtDecode } from 'jwt-decode';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const AUTH_TOKEN_KEY = 'auth-info';

interface Tokens {
  accessToken: string;
  refreshToken: string;
  userInfo: {
    username: string;
    broker: string;
    email?: string;
    mobile?: number | null;
    name?: string;
    clientType?: string;
  };
}

type AuthState = Tokens & {
  setTokens: (arg0: Omit<Tokens, 'userInfo'>) => void;
  setUserDetails: (userdetail: {
    username: string;
    broker: string;
    email?: string;
    mobile?: number | null;
    name?: string;
    clientType?: string;
  }) => void;
  clearTokens: () => void;
};

export const useTokens = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: '',
      refreshToken: '',
      userInfo: {
        username: '',
        broker: '',
        email: '',
        mobile: null,
        name: '',
      },
      setTokens: ({ accessToken, refreshToken }) => {
        let userInfo = get().userInfo;
        if (accessToken.length) {
          const decoded = jwtDecode<{
            username: string;
            current_broker: string;
            email: string;
            mobile: number;
            name: string;
          }>(accessToken);
          userInfo = {
            username: decoded?.username,
            broker: decoded?.current_broker,
            email: decoded?.email,
            mobile: decoded?.mobile,
            name: decoded?.name,
          };
        }
        set({ accessToken, refreshToken, userInfo });
      },
      setUserDetails: (userdetail) => {
        set({
          userInfo: {
            ...get().userInfo,
            username: userdetail.username,
            broker: userdetail.broker,
            clientType: userdetail?.clientType,
          },
        });
      },

      clearTokens: () => set({ accessToken: '', refreshToken: '' }),
    }),
    {
      name: AUTH_TOKEN_KEY,
    }
  )
);
